// import Api from '../../Services/ApiCall'
import { Link } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import BarChart from 'react-easy-bar-chart';
import toast, { Toaster } from 'react-hot-toast';
import Api from './Services/ApiCall'
import css from '../App'
// import Paper from '@material-ui/core/Paper';
// import {
//     ArgumentAxis,
//     ValueAxis,
//     Chart,
//     BarSeries,
// } from '@devexpress/dx-react-chart-matevrial-ui';


const testt = {
    background: "rgb(0 0 0 / 26%)"
}
const viewbtn = {
    borderRadius: "10px",
    float: "right",
    backgroundColor: "#222a44",
    color: "#fff",
    borderColor: "none",
    height: "30px",
    width: "50px",
}


// const maincollapse ={
// marginLeft:"-300px"
// }
function MainDashboard() {
    let data;
    try{
         data = [
            {
                title: "Agent",
                //value:{width: agentList.length},
                value: "6"/ 100,
                color: "#196f3d",
            },
            {
                title: "Employee",
                //value: employeeList.length,
                value: "5" / 100,
                color: "#a93226",
            },
            {
                title: "Employer",
                //value: listdata.length,
                value: "6" / 100,
                color: " #1f618d",
            },
            {
                title: "Jobseeker",
                //value: listdata1.length,
                value: "15" / 100,
                color: "#839192",
            },

        ];
    }
    catch{}

    const [checked, setChecked] = useState(false);
    const [checked1, setChecked1] = useState(false);
    const [Ittable, setItprocess] = useState(false);
    const [Enggtable, setEnggprocess] = useState(false);
    const [Testingtable, setTestingprocess] = useState(false);
    const [Marketingtable, setMarketingprocess] = useState(false);
    const test = () => {
        setChecked(true)
        setChecked1(false)
    }

    const test1 = () => {
        setEnggprocess(false)
        setItprocess(false)
        setChecked(false)
        setChecked1(true)
    }

    const Itprocess = () => {
        setEnggprocess(false)
        setItprocess(true)
    }
    const Enggprocess = () => {
        setItprocess(false)
        setEnggprocess(true)

    }
    const Testing = () => {
        setMarketingprocess(false)
        setTestingprocess(true)
    }

    const Marketing = () => {
        setTestingprocess(false)
        setMarketingprocess(true)
    }


    const [cashiertable, setCashier] = useState(false);
    const [salesmantable, setSalesman] = useState(false);
    const cashier = () => {
        setSalesman(false)
        setCashier(true)
        toast.error('Pay the premium package get more jobs updates');
    }
    const salesman = () => {
        setCashier(false)
        setSalesman(true)
        toast.error('Pay the premium  package get more jobs updates');
    }

    const [candidatelisttable, setCandidatelist] = useState(false);
    const [candidatelisttable1, setCandidatelist1] = useState(false);
    const candidatelist = () => {
        setCandidatelist1(false)
        setCandidatelist(true)
        toast.error('Pay the premium package get more jobseeker profile');

    }
    const candidatelist1 = () => {
        setCandidatelist(false)
        setCandidatelist1(true)
        toast.error('Pay the premium package get more jobseeker profile');
    }


    function checkmenu(id) {
        return menu.filter(function (menu) {
            try {

                return menu.MenuID == id;
            }
            catch {

                return menu.MenuID == id;
            }

        });
    }
    const [listdata, setlistdata] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [agentList, setAgentList] = useState([]);
   
    const [listdata1, setJobseekerlistdata] = useState([]);
    const menu = JSON.parse(sessionStorage.getItem("roleaccess"))
    // const [_Usertype, set_Usertype] = useState("");
    async function checkBoxMenuValidation(e) {
        set_Usertype(e.target.value);
        let _a1 = [];
        _a1.push(e.target.value)
        var Param = { mstuserregid: 0, rolecab: JSON.stringify(_a1) }
        var url = "/UserReg/GetUserRegtable";
        let _response1 = await Api.BindGrid(Param, url)
      
        setlistdata(_response1)
    }

    let _a = [];
   
    useEffect(() => {

        Checkvalidation()
       
    }, []);
    async function Checkvalidation() {


        try {
            if (checkmenu(4)[0]['View'] == 1) {
                set_Usertype("Employer")
                _a.push("Employer")
                let _a1 = [];
                _a1.push("Employer")
                var Param = { mstuserregid: 0, rolecab: JSON.stringify(_a1) }
                var url = "/UserReg/GetUserRegtable";
                let _response1 = await Api.BindGrid(Param, url)
              
                setlistdata(_response1)
            }
        }
        catch {

        }

    }

    function checkmenu(id) {
        return menu.filter(function (menu) {
            try {

                return menu.MenuID == id;
            }
            catch {

                return menu.MenuID == id;
            }

        });
    }

    const [_Usertype, set_Usertype] = useState("");
    async function checkBoxMenuValidation(e) {
        set_Usertype(e.target.value);
        let _a1 = [];
        _a1.push(e.target.value)
        var Param = { mstuserregid: 0, rolecab: JSON.stringify(_a1) }
        var url = "/UserReg/GetUserRegtable";
        let _response1 = await Api.BindGrid(Param, url)
     
        setlistdata(_response1)
    }

    async function BindGrid() {
        let _a1 = [];
        _a1.push(_Usertype)
        var Param = { mstuserregid: 0, rolecab: JSON.stringify(_a1) }
        var url = "/UserReg/GetUserRegtable";
        let _response1 = await Api.BindGrid(Param, url)
        
        setlistdata(_response1)
    }
    async function GetEmployeeList() {
        let _a1 = [];
        _a1.push("Employee")
        var Param = { mstuserregid: 0, rolecab: JSON.stringify(_a1) }
        var url = "/UserReg/GetUserRegtable";
        let _response1 = await Api.BindGrid(Param, url)
        
        setEmployeeList(_response1)
    }
    async function GetAgentList() {
        let _a1 = [];
        _a1.push("Agent")
        var Param = { mstuserregid: 0, rolecab: JSON.stringify(_a1) }
        var url = "/UserReg/GetUserRegtable";
        let _response1 = await Api.BindGrid(Param, url)
       
        setAgentList(_response1)
    }

    useEffect(() => {

        BindGrid(0)
        GetEmployeeList(0)
        GetAgentList(0)
        GetRole()
        //checkmenu()
    }, []);
    async function BindGrid(id) {
        var Param = { mstjobseekerid: id }
        var url = "/JobSeekerTable/BindJobSeekerTable";
        let _response1 = await Api.BindGrid(Param, url)
        setJobseekerlistdata(_response1)

    }
    const [role, setRole] = useState("");
    async function GetRole() {
        var id = JSON.parse(sessionStorage.getItem('userdetails'))[0]['Usertype'];
        var url = "/DropDown/Rolecheck?id=" + id;
        let _response = await Api.BindDropdown(url)
        let Arry_Title1 = [];
        setRole(_response)
        sessionStorage.setItem("ApproveRole", _response);
    }

   
    
    return (
        <div id="main" class="main" >
            <Toaster toastOptions={{ position: "top-right" }} />
            {sessionStorage.getItem("item_key") == "agent" ?
                <div class="pagetitle">
                    <h1>Dashboard</h1>
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">  <Link to="/dash">Home</Link></li>
                            <li class="breadcrumb-item active">agent</li>
                        </ol>
                    </nav>


                    <div class="col-xxl-12 col-md-12">
                        <div class="card info-card revenue-card" >


                            <div class="card-body">
                                <h5 class="card-title">Welcome Siva<span></span></h5>

                                <div class="d-flex align-items-center">


                                </div>
                            </div>

                        </div>
                    </div>




                </div> : null}
            {sessionStorage.getItem("item_key") == "employee" ?
                <div class="pagetitle">
                    <h1>Dashboard</h1>
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">  <Link to="/dash">Home</Link></li>
                            <li class="breadcrumb-item active">Employee</li>
                        </ol>
                    </nav>

                    <div class="col-xxl-12 col-md-12">
                        <div class="card info-card revenue-card" >


                            <div class="card-body">
                                <h5 class="card-title">Welcome gopi<span></span></h5>

                                <div class="d-flex align-items-center">


                                </div>
                            </div>

                        </div>
                    </div>


                </div> : null}
            {sessionStorage.getItem("item_key") == "job" ?
                <div class="pagetitle">
                    <h1>Dashboard</h1>
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">  <Link to="/dash">Home</Link></li>
                            <li class="breadcrumb-item active">Jobseeker</li>
                        </ol>
                    </nav>

                    <div class="col-xxl-12 col-md-12">
                        <div class="card info-card revenue-card" >


                            <div class="card-body">
                                <h5 class="card-title">Welcome Arul<span></span></h5>

                                <div class="d-flex align-items-center">


                                </div>
                            </div>

                        </div>
                    </div>

                </div> : null}
            {sessionStorage.getItem("item_key") == "employer" ?
                <div class="pagetitle">
                    <h1>Dashboard</h1>
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">  <Link to="/dash">Home</Link></li>
                            <li class="breadcrumb-item active">Employer</li>
                        </ol>
                    </nav>
                    <div class="col-xxl-12 col-md-12">
                        <div class="card info-card revenue-card" >


                            <div class="card-body">
                                <h5 class="card-title">Welcome Hari<span></span></h5>

                                <div class="d-flex align-items-center">


                                </div>
                            </div>

                        </div>
                    </div>

                </div> : null}

            {/* <!-- End Page Title --> */}
            {/* {sessionStorage.getItem("item_key") == "admin" ? */}
            <section class="section dashboard">
                <div class="row">

                    {/* <!-- Left side columns --> */}
                    <div class="col-lg-8">
                        <div class="row">

                            {/* <!-- Recent Sales --> */}
                            <div class="col-12">
                                <div class="card recent-sales overflow-auto">

                                    <div class="divGroup col-md-12">
                                        {checkmenu(4)[0]['View'] == 1 ? <>
                                            <input type="radio" id="Employer" value="Employer" checked={_Usertype == "Employer"} onChange={(e) => checkBoxMenuValidation(e)} />
                                            <label for="Employer" class="test">Employer</label>
                                        </> : null}  {checkmenu(3)[0]['View'] == 1 ? <>
                                            <input type="radio" id="Jobseeker" value="Jobseeker" checked={_Usertype == "Jobseeker"} onChange={(e) => checkBoxMenuValidation(e)} />
                                            <label for="Jobseeker" class="test">Job Seeker</label>
                                        </> : null}
                                    </div>

                                    <div class="card-body">
                                        {/* <h5 class="card-title">Details Table</h5> */}
                                        <h5 class="card-title"> {_Usertype} </h5>
                                        {_Usertype == "Employer" ?
                                            <table class="table table-borderless datatable">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">No</th>
                                                        <th scope="col">Code</th>
                                                        <th scope="col">Name</th>
                                                        <th scope="col">Emailid</th>
                                                        <th scope="col">Aadhar Number</th>
                                                        <th scope="col">Subscribe</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {listdata &&
                                                        listdata.map((i, index) => (

                                                            <tr key={index}>
                                                                <th scope="row">{index + 1}</th>
                                                                <td>{i.Msusertregcode}</td>
                                                                <td>{i.Name}</td>
                                                                <td>{i.Emailid}</td>
                                                                <td>{i.Aadhaarnumber}</td>
                                                                <td>{i.Subscribe}</td>

                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                            :
                                            <table class="table table-borderless datatable">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">No</th>
                                                        <th scope="col">Code</th>
                                                        <th scope="col">Name</th>
                                                        <th scope="col">Emailid</th>
                                                        <th scope="col">Aadhar Number</th>
                                                        <th scope="col">Subscribe</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {listdata1.map((i, index) => (

                                                        <tr key={index}>
                                                            <th scope="row">{index + 1}</th>
                                                            <td>{i.Mstjobseekercode}</td>
                                                            <td>{i.Name}</td>
                                                            <td>{i.Email}</td>
                                                            <td>{i.Aadhaarnumber}</td>
                                                            <td>{i.Subscribe}</td>

                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                        }

                                    </div>

                                </div>
                            </div>
                            {/* <!-- End Recent Sales --> */}

                        </div>
                    </div>
                    {/* <!-- End Left side columns --> */}

                    {/* <!-- Right side columns --> */}
                    <div class="col-lg-4">

                        {/* <!-- Recent Activity --> */}
                        {/* <div class="card">
                           
                                <div class="card-body pb-0">
                                    <h5 class="card-title">Bar Chart</h5>
                                    <BarChart
                                        xAxis='React Bar Chart'
                                        yAxis="Values"
                                        height={300}
                                        width={300}
                                        data={data}
                                    />
                                </div>
                           
                        </div> */}
                        {/* <!-- End Recent Activity --> */}

                        {/* <!-- Budget Report --> */}
                        <div class="card">


                            <div class="card-body pb-4">
                                <h5 class="card-title">Progress Stage</h5>

                                <h5 class="card-title">Agent</h5>
                                <div class="progress">

                                    <div class="progress-bar bg-success" role="progressbar" style={{ width: agentList.length / 100*100 }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <h5 class="card-title">Employee</h5>
                                <div class="progress">

                                    <div class="progress-bar bg-info" role="progressbar" style={{ width: employeeList.length / 100 *100}} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <h5 class="card-title">Employer</h5>
                                <div class="progress">

                                    <div class="progress-bar bg-warning" role="progressbar" style={{ width: listdata.length / 100 *100}} aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                                <h5 class="card-title">Jobseeker</h5>
                                <div class="progress">

                                    <div class="progress-bar bg-danger" role="progressbar" style={{ width: listdata1.length / 100 *100}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- End Budget Report --> */}

                        {/* <!-- Website Traffic --> */}

                    </div>
                    {/* <!-- End Right side columns --> */}

                </div>
            </section>
            {/* : null} */}

            {sessionStorage.getItem("item_key") == "job" ?



                <div class="col-lg-12">
                    <div class="row">


                        <div class="col-xxl-6 col-md-4">
                            <div class="card info-card sales-card" style={cashiertable ? testt : {}} >

                                <div class="card-body"  >
                                    <h5 class="card-title" > Vacancy In Cashier <span><i class="bi bi-arrow-right-circle-fill"></i></span></h5>
                                    <div class="d-flex align-items-center">
                                        <button style={viewbtn} onClick={cashier}  > view</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-xxl-6 col-md-4">
                            <div class="card info-card revenue-card" style={salesmantable ? testt : {}} >


                                <div class="card-body">
                                    <h5 class="card-title">Vacancy In Salesman<span><i class="bi bi-arrow-right-circle-fill"></i></span></h5>

                                    <div class="d-flex align-items-center">
                                        <buttton style={viewbtn} onClick={salesman}>view</buttton>

                                    </div>
                                </div>

                            </div>
                        </div>
                        {cashiertable ?
                            <div class="col-12">
                                <div class="card recent-sales overflow-auto">
                                    <div class="card-body">
                                        <h5 class="card-title">Cashier Vacancy</h5>
                                        <table class="table table-borderless datatable">
                                            <thead>
                                                <tr>

                                                    <th scope="col">Job Updated on</th>
                                                    <th scope="col">Employer Name</th>
                                                    <th scope="col">Qualification</th>
                                                    <th scope="col">Experience/Freshers</th>
                                                    <th scope="col">Designation</th>
                                                    <th scope="col">Vacancy</th>
                                                    <th scope="col">Location</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>

                                                    <td>01/09/2022</td>
                                                    <td>Saravana Stores </td>
                                                    <td>BCom </td>
                                                    <td>3 yrs Exp</td>
                                                    <td>Account</td>
                                                    <td>5 nos</td>
                                                    <td>Chennai </td>

                                                </tr>
                                                <tr>

                                                    <td>01/09/2022</td>
                                                    <td>Vedha Textiles </td>
                                                    <td>Any Degree</td>
                                                    <td>Fresher</td>
                                                    <td>Cashier</td>
                                                    <td>5 nos</td>
                                                    <td>Chennai </td>

                                                </tr>
                                                <tr>

                                                    <td>02/09/2022</td>
                                                    <td>Vijaya Textiles </td>
                                                    <td>12th</td>
                                                    <td>Fresher</td>
                                                    <td>Cashier</td>
                                                    <td>5 nos</td>
                                                    <td>Chennai </td>
                                                    {/* <td><a  class="text-primary">Blanditiis dolor omnis similique</a></td>
                                                  <td>$47</td>
                                                  <td><span class="badge bg-warning">Pending</span></td> */}
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div >
                                </div >
                            </div > : null
                        }
                        {
                            salesmantable ?
                                <div class="col-12">
                                    <div class="card recent-sales overflow-auto">
                                        <div class="card-body">
                                            <h5 class="card-title">Salesman Vacancy</h5>
                                            <table class="table table-borderless datatable">
                                                <thead>
                                                    <tr>

                                                        < th scope="col">Job Updated on</th>
                                                        <th scope="col">Employer Name</th>
                                                        <th scope="col">Qualification</th>
                                                        <th scope="col">Experience/Freshers</th>
                                                        <th scope="col">Designation</th>
                                                        <th scope="col">Vacancy</th>
                                                        <th scope="col">Location</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>

                                                        <td>02/09/2022</td>
                                                        <td>GunaTextiles </td>
                                                        <td>12th</td>
                                                        <td>Fresher</td>
                                                        <td>Sales Man</td>
                                                        <td>5 nos</td>
                                                        <td>Chennai </td>

                                                    </tr>
                                                    <tr>

                                                        <td>02/09/2022</td>
                                                        <td>Vijaya Textiles </td>
                                                        <td>Any Degree</td>
                                                        <td>2 yrs Exp</td>
                                                        <td>Sales Executive</td>
                                                        <td>5 nos</td>
                                                        <td>Chennai </td>

                                                    </tr >
                                                    <tr>
                                                        <td>02/09/2022</td>
                                                        <td>Vijaya Textiles </td>
                                                        <td>12th</td>
                                                        <td>Fresher</td>
                                                        <td>Cashier</td>
                                                        <td>5 nos</td>
                                                        <td>Coimbatore </td>
                                                    </tr>
                                                </tbody >
                                            </table >
                                        </div >
                                    </div >
                                </div > : null
                        }
                    </div>
                </div> : null}



            {sessionStorage.getItem("item_key") == "employer" ?
                <div class="col-lg-12">

                    <div class="row">
                        <div class="col-lg-12">
                            <div class="row">


                                <div class="col-xxl-6 col-md-4">
                                    <div class="card info-card sales-card" style={candidatelisttable ? testt : {}} >

                                        <div class="card-body"  >
                                            <h5 class="card-title" > Candidate Matched Profile for  Cashier <span><i class="bi bi-arrow-right-circle-fill"></i></span></h5>
                                            <div class="d-flex align-items-center">
                                                <button style={viewbtn} onClick={candidatelist}  >View</button>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div class="col-xxl-6 col-md-4">
                                    <div class="card info-card revenue-card" style={candidatelisttable1 ? testt : {}} >


                                        <div class="card-body">
                                            <h5 class="card-title">Candidate Matched Profile for Salesman<span><i class="bi bi-arrow-right-circle-fill"></i></span></h5>

                                            <div class="d-flex align-items-center">
                                                <buttton style={viewbtn} onClick={candidatelist1} >view</buttton>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {candidatelisttable ?
                            <div class="col-12">
                                <div class="card recent-sales overflow-auto">
                                    <div class="card-body">
                                        <h5 class="card-title">Shortlist Candidate Cashier </h5>
                                        <table class="table table-borderless datatable">
                                            <thead>
                                                <tr>

                                                    < th scope="col">Candidate Updated on</th>
                                                    <th scope="col">Candidate Name</th>
                                                    <th scope="col">Qualification</th>
                                                    <th scope="col">Experience/Freshers</th>
                                                    <th scope="col">Designation</th>
                                                    <th scope="col">Native District</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>

                                                    <td>01/09/2022</td>
                                                    <td>S.Ramu </td>
                                                    <td>BCom </td>
                                                    <td>Fresher</td>
                                                    <td>NA</td>
                                                    <td>Tirunelveli</td>

                                                </tr>
                                                <tr>
                                                    <td>01/09/2022</td>
                                                    <td>S.Ramu </td>
                                                    <td>BCom </td>
                                                    <td>Fresher</td>
                                                    <td>NA</td>
                                                    <td>Tirunelveli</td>
                                                </tr>
                                                <tr>
                                                    <td>01/09/2022</td>
                                                    <td>S.Ramu </td>
                                                    <td>BCom </td>
                                                    <td>Fresher</td>
                                                    <td>NA</td>
                                                    <td>Tirunelveli</td>

                                                </tr >
                                            </tbody >
                                        </table >
                                    </div >
                                </div >
                            </div > : null}

                        {
                            candidatelisttable1 ?
                                <div class="col-12">
                                    <div class="card recent-sales overflow-auto">
                                        <div class="card-body">
                                            <h5 class="card-title">Candidate Matched Profile For Salesman </h5>
                                            <table class="table table-borderless datatable">
                                                <thead>
                                                    <tr>

                                                        < th scope="col">Candidate Updated on</th>
                                                        <th scope="col">Candidate Name</th>
                                                        <th scope="col">Qualification</th>
                                                        <th scope="col">Experience/Freshers</th>
                                                        <th scope="col">Designation</th>
                                                        <th scope="col">Native District</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>

                                                        <td>01/09/2022</td>
                                                        <td>S.Ramu </td>
                                                        <td>BCom </td>
                                                        <td>Fresher</td>
                                                        <td>NA</td>
                                                        <td>Tirunelveli</td>



                                                    </tr>
                                                    <tr>

                                                        <td>01/09/2022</td>
                                                        <td>S.Ramu </td>
                                                        <td>BCom </td>
                                                        <td>Fresher</td>
                                                        <td>NA</td>
                                                        <td>Tirunelveli</td>

                                                    </tr >
                                                    <tr>
                                                        <td>01/09/2022</td>
                                                        <td>S.Ramu </td>
                                                        <td>BCom </td>
                                                        <td>Fresher</td>
                                                        <td>NA</td>
                                                        <td>Tirunelveli</td>
                                                    </tr>
                                                </tbody >
                                            </table >
                                        </div >
                                    </div >
                                </div > : null}
                    </div>
                </div > : null}







        </div>

    )
}

export default MainDashboard